"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
require("bootstrap/dist/css/bootstrap.css");
var Layout_1 = require("./components/Layout");
var Home_1 = require("./components/Home");
var Admin_1 = require("./components/CustomPanel/Admin");
var myTheme = office_ui_fabric_react_1.createTheme({
    palette: {
        themePrimary: '#d40004',
        themeLighterAlt: '#cfdeec',
        themeLighter: '#a8c2da',
        themeLight: '#84a7c8',
        themeTertiary: '#648fb7',
        themeSecondary: '#4978a5',
        themeDarkAlt: '#316493',
        themeDark: '#1d5182',
        themeDarker: '#0c4070',
        neutralLighterAlt: '#faf9f8',
        neutralLighter: '#f3f2f1',
        neutralLight: '#edebe9',
        neutralQuaternaryAlt: '#e1dfdd',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c6c4',
        neutralTertiary: '#a19f9d',
        neutralSecondary: '#605e5c',
        neutralPrimaryAlt: '#3b3a39',
        neutralPrimary: '#323130',
        neutralDark: '#201f1e',
        black: '#000000',
        white: '#ffffff',
    }
});
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        return _super.call(this, props) || this;
    }
    App.prototype.render = function () {
        office_ui_fabric_react_1.Customizations.applySettings({ theme: myTheme });
        var contents = this.renderContent();
        return (React.createElement("div", null,
            React.createElement(react_router_dom_1.BrowserRouter, null, contents)));
    };
    App.prototype.renderContent = function () {
        return (React.createElement(Layout_1.default, null,
            React.createElement(react_router_dom_1.Switch, null,
                React.createElement(react_router_dom_1.Route, { exact: true, path: '/', component: Home_1.default }),
                React.createElement(react_router_dom_1.Route, { exact: true, path: '/Admin', component: Admin_1.default }),
                React.createElement(react_router_dom_1.Route, { exact: true, path: '/:item', component: Home_1.default }),
                React.createElement(react_router_dom_1.Route, { exact: true, path: '/:item/:id', component: Home_1.default }))));
    };
    return App;
}(react_1.Component));
exports.default = App;
//# sourceMappingURL=app.js.map